// Only initialize if not embedded in an iFrame
if (window.top === window.self) {
  window.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('.aps-announcement').length) {
      let $announcement = document.querySelector('.aps-announcement')
      let modified = $announcement.dataset.modified
      let prevModified = localStorage.getItem('apsAnnouncementModified')

      if (!prevModified || prevModified !== modified) {
        $announcement.style.display = 'flex'
        document.body.classList.add('is-announcement')

        let $announcementClose = $announcement.querySelector(
          '.aps-announcement__close'
        )

        $announcementClose.addEventListener('click', function (ev) {
          ev.preventDefault()
          ev.stopPropagation()
          localStorage.setItem('apsAnnouncementModified', modified)
          $announcement.style.marginTop = '-' + $announcement.clientHeight + 'px'
          document.body.classList.remove('is-announcement')
          setTimeout(function () {
            $announcement.style.display = 'none'
          }, 300)
        })
      }
    }
  })
}
